<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="productSpecManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item label="规格名称">
              <el-input v-model="productSpecManageInfo.conditions.specName" placeholder="请输入规格名称" clearable />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item label="规格编号">
              <el-input v-model="productSpecManageInfo.conditions.specId" placeholder="请输入规格编号" clearable />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryProductSpecMethod">
              <i class="el-icon-search"></i>查询
            </el-button>
            <el-button @click="_resetProductSpecMethod">
              <i class="el-icon-refresh"></i>重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>商品规格</span>
        <el-button type="primary" size="small" style="float: right;" @click="_openAddProductSpecModal">
          <i class="el-icon-plus"></i>添加
        </el-button>
      </div>
      <div class="">
        <el-table :data="productSpecManageInfo.productSpecs" border style="width: 100%">
          <el-table-column prop="specId" label="规格编号" align="center" />
          <el-table-column prop="specName" label="规格名称" align="center" />
          <el-table-column label="规格值" align="center">
            <template slot-scope="scope">
              <span v-html="scope.row.specValue"></span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" />
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button size="mini" @click="_openEditProductSpecModel(scope.row)">修改</el-button>
              <el-button size="mini" type="danger" @click="_openDeleteProductSpecModel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="productSpecManageInfo.conditions.page"
          :page-size="productSpecManageInfo.conditions.row" layout="total, prev, pager, next"
          :total="productSpecManageInfo.total" style="margin-top: 20px;" />
      </div>
    </el-card>

    <add-product-spec ref="addProductSpec" @refresh="_listProductSpecs" />
    <edit-product-spec ref="editProductSpec" @refresh="_listProductSpecs" />
    <delete-product-spec ref="deleteProductSpec" @refresh="_listProductSpecs" />
  </div>
</template>

<script>
import { getProductSpecList } from '@/api/goods/productSpecApi'
import AddProductSpec from '@/components/goods/addProductSpec/addProductSpec'
import EditProductSpec from '@/components/goods/editProductSpec/editProductSpec'
import DeleteProductSpec from '@/components/goods/deleteProductSpec/deleteProductSpec'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ProductSpecManage',
  components: {
    AddProductSpec,
    EditProductSpec,
    DeleteProductSpec
  },
  data() {
    return {
      productSpecManageInfo: {
        productSpecs: [],
        total: 0,
        conditions: {
          page: 1,
          row: 10,
          specName: '',
          specId: '',
          shopId: ''
        }
      }
    }
  },
  created() {
    this.productSpecManageInfo.conditions.shopId = getShopId()
    this._listProductSpecs()
  },
  methods: {
    handleCurrentChange(val) {
      this.productSpecManageInfo.conditions.page = val
      this._listProductSpecs()
    },
    async _listProductSpecs() {
      try {
        const res = await getProductSpecList(this.productSpecManageInfo.conditions)
        this.productSpecManageInfo.productSpecs = res.data.map(item => {
          if (item.productSpecDetails) {
            item.specValue = item.productSpecDetails
              .map(detail => `${detail.detailName}:${detail.detailValue}`)
              .join('<br/>')
          }
          return item
        })
        this.productSpecManageInfo.total = res.total
      } catch (error) {
        console.error('获取规格列表失败:', error)
      }
    },
    _openAddProductSpecModal() {
      this.$refs.addProductSpec.open()
    },
    _openEditProductSpecModel(row) {
      this.$refs.editProductSpec.open(row)
    },
    _openDeleteProductSpecModel(row) {
      this.$refs.deleteProductSpec.open(row)
    },
    _queryProductSpecMethod() {
      this.productSpecManageInfo.conditions.page = 1
      this._listProductSpecs()
    },
    _resetProductSpecMethod() {
      this.productSpecManageInfo.conditions = {
        page: 1,
        row: 10,
        specName: '',
        specId: '',
        shopId: getShopId()
      }
      this._listProductSpecs()
    }
  }
}
</script>

<style scoped>
.card-body {
  padding: 20px;
}
</style>